import React, { useState, lazy } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, QuoteIcon } from 'lucide-react';
const CustomerStories = () => {
  const [activeStory, setActiveStory] = useState(0);
  const stories = [{
    company: 'TechSphere Inc.',
    industry: 'Tech Company',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/juEvfy8eZq6PSxDVaETps7/Customer_Success_1.webp',
    quote: "Our team raves about the SmartSoda system. It's become a favorite perk and conversation starter when clients visit. The ROI has been impressive - we've eliminated over 45,000 single-use bottles annually.",
    person: 'David Park',
    title: 'Facilities Director',
    results: [{
      metric: '$28K',
      description: 'Annual savings'
    }, {
      metric: '45K+',
      description: 'Plastic bottles eliminated yearly'
    }, {
      metric: '92%',
      description: 'Employee satisfaction with beverages'
    }]
  }, {
    company: 'Horizon Financial',
    industry: 'Financial Services',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/96FUarC5b8FATpopq2eFFw/Customer_Success_2.webp',
    quote: "SmartSoda has been transformative for our office environment. Our employees appreciate the variety of options, and we've seen a significant reduction in our environmental footprint while cutting our beverage expenses.",
    person: 'Sarah Johnson',
    title: 'Office Operations Manager',
    results: [{
      metric: '35%',
      description: 'Cost reduction'
    }, {
      metric: '87%',
      description: 'Waste reduction'
    }, {
      metric: '4.9/5',
      description: 'Employee satisfaction rating'
    }]
  }, {
    company: 'Nexus Innovations',
    industry: 'Software Development',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1eko4FUB2io47aRTVTjhLH/Customer_Success_3.webp',
    quote: 'As a fast-growing tech company, we needed a beverage solution that was sustainable, cost-effective, and appealing to our talent. SmartSoda delivers on all fronts and has become a highlight of our office amenities.',
    person: 'Michael Chen',
    title: 'Chief People Officer',
    results: [{
      metric: '22%',
      description: 'Increase in office satisfaction'
    }, {
      metric: '$31K',
      description: 'Annual cost savings'
    }, {
      metric: '0',
      description: 'Plastic bottles purchased'
    }]
  }, {
    company: 'Global Consulting Group',
    industry: 'Professional Services',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nQNWphrftbhgLHwqaG2Mpy/Customer_Success_4.webp',
    quote: "Our clients and employees alike comment on our SmartSoda system. It's not just a beverage station - it's a statement about our company values around sustainability and employee wellness.",
    person: 'Jessica Rivera',
    title: 'Workplace Experience Director',
    results: [{
      metric: '41%',
      description: 'Reduction in beverage costs'
    }, {
      metric: '30K',
      description: 'Single-use items eliminated'
    }, {
      metric: '94%',
      description: 'Positive employee feedback'
    }]
  }];
  const nextStory = () => {
    setActiveStory(prev => (prev + 1) % stories.length);
  };
  const prevStory = () => {
    setActiveStory(prev => (prev - 1 + stories.length) % stories.length);
  };
  const story = stories[activeStory];
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-blue-50" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-10 md:mb-16" data-id="element-145">
          <h2 className="text-2xl md:text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-146">
            Customer Success Stories
          </h2>
          <p className="mt-4 text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-147">
            See how offices like yours are transforming their workplace beverage
            programs with SmartSoda
          </p>
        </div>
        <div className="bg-white rounded-xl md:rounded-2xl shadow-lg md:shadow-xl overflow-hidden" data-id="element-148">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-149">
            {/* Image Section */}
            <div className="relative h-56 sm:h-64 lg:h-auto" data-id="element-150">
              <img src={story.image} alt={`${story.company} using SmartSoda`} className="absolute inset-0 w-full h-full object-cover" width="600" height="400" loading="lazy" decoding="async" data-id="element-151" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end" data-id="element-152">
                <div className="p-4 md:p-6" data-id="element-153">
                  <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-154">
                    {story.company}
                  </h3>
                  <p className="text-xs md:text-sm text-white/80" data-id="element-155">
                    {story.industry}
                  </p>
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="p-5 sm:p-6 md:p-8 lg:p-10 flex flex-col justify-between" data-id="element-156">
              <div data-id="element-157">
                <div className="mb-5 md:mb-6" data-id="element-158">
                  <QuoteIcon className="h-8 w-8 md:h-10 md:w-10 text-blue-400 mb-3 md:mb-4" data-id="element-159" />
                  <blockquote className="text-base md:text-lg lg:text-xl text-gray-700 italic mb-4 md:mb-6" data-id="element-160">
                    "{story.quote}"
                  </blockquote>
                  <div className="flex items-center" data-id="element-161">
                    <div data-id="element-162">
                      <p className="font-medium text-navy-950" data-id="element-163">
                        {story.person}
                      </p>
                      <p className="text-xs md:text-sm text-gray-500" data-id="element-164">
                        {story.title}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-165">
                  {story.results.map((result, index) => <div key={index} className="bg-blue-50 p-3 md:p-4 rounded-lg text-center" data-id="element-166">
                      <p className="text-xl md:text-2xl font-bold text-blue-600" data-id="element-167">
                        {result.metric}
                      </p>
                      <p className="text-xs md:text-sm text-gray-600" data-id="element-168">
                        {result.description}
                      </p>
                    </div>)}
                </div>
              </div>
              <div className="flex justify-between items-center" data-id="element-169">
                <div className="flex space-x-2" data-id="element-170">
                  {stories.map((_, index) => <button key={index} onClick={() => setActiveStory(index)} className={`h-2 w-2 md:h-2.5 md:w-2.5 rounded-full ${index === activeStory ? 'bg-blue-500' : 'bg-gray-300'}`} aria-label={`Go to story ${index + 1}`} data-id="element-171"></button>)}
                </div>
                <div className="flex space-x-2" data-id="element-172">
                  <button onClick={prevStory} className="p-1.5 md:p-2 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors" aria-label="Previous story" data-id="element-173">
                    <ArrowLeftIcon className="h-4 w-4 md:h-5 md:w-5 text-gray-600" data-id="element-174" />
                  </button>
                  <button onClick={nextStory} className="p-1.5 md:p-2 rounded-full border border-gray-300 hover:bg-gray-100 transition-colors" aria-label="Next story" data-id="element-175">
                    <ArrowRightIcon className="h-4 w-4 md:h-5 md:w-5 text-gray-600" data-id="element-176" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 md:mt-12 text-center" data-id="element-177">
          <a href="#book-demo" className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 border border-transparent text-sm md:text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-178">
            Join Our Success Stories
          </a>
        </div>
      </div>
    </section>;
};
export default CustomerStories;